import { lazyNamed } from 'src/utils/lazyNamed';

export const Billing = {
  Layout: lazyNamed(() => import('./components/Layout'), 'Layout'),
  TransactionsHistory: lazyNamed(() => import('./containers/TransactionsHistory'), 'TransactionsHistory'),
  PaymentMethods: lazyNamed(() => import('./containers/PaymentMethods'), 'PaymentMethods'),
};
